export default "__VITE_ASSET__46e81176__"